module.exports = __webpack_public_path__ + "static/img/tooltip-sun-synchronous-orbit.84883ea.png";